
import { Vue, Options } from "vue-class-component";
import { FlagsPermissionPusatResolusiV2 } from "@/feature-flags/flags-pusat-resolusi-v2";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import CustomDropdown from "@/app/ui/components/custom-dropdown/index.vue";
import Checkbox from "primevue/checkbox";
import ModalCheckIssue from './components/check-issue/modal-check-issue.vue';
import PopupIssueInformation from './components/check-issue/popup-issue-information.vue';
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { CheckIssuePusatResolusi } from '@/domain/entities/PusatResolusiV2';
import { PusatResolusiV2Controller } from '../../controllers/PusatResolusiV2Controller';
import { CheckTicketPusatResolusiRequest } from '@/data/payload/api/PusatResolusiV2ApiRequest';
import PusatResolusiV2TabTicket from "./components/tab-ticket.vue";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";

@Options({
  components: {
    Skeleton,
    CustomDropdown,
    Checkbox,
    ModalCheckIssue,
    PopupIssueInformation,
    PusatResolusiV2TabTicket
  },
})

export default class PusatResolusiV2 extends Vue {
  showModalCheckIssue = false;
  showPopupReportIssue = false;
  showPopupInformationIssue = false;
  isError = false;
  errorCause = "";
  refNo: any = "";

  onClickCheckIssueButton() {
    this.showModalCheckIssue = !this.showModalCheckIssue;
  }

  onCloseReportIssue() {
    this.showPopupReportIssue = false;
    this.onClickCheckIssueButton();
  }

  onClosePopupInformationIssue() {
    this.showPopupInformationIssue = false;
    this.onClickCheckIssueButton();
  }

  onReportIssue(refNo: any) {
    this.refNo = refNo;
    this.onCheck();
  }

  get showCekKendalaButton() {
    return FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_cek_kendala.isEnabled();
  }

  get showBuatKendalaButton() {
    return FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_buat_kendala.isEnabled();
  }

  toCreate(refNo = "") {
    const referenceNumber = refNo ? `?sttNo=${refNo}` : '';
    this.$router.push(`/pusat-resolusi-v2/create${referenceNumber}`);
  }
  
  toDetail(id: number) {
    this.$router.push(`/pusat-resolusi-v2/detail/${id}`);
  }

  ticketIssue = new CheckIssuePusatResolusi();
  async onCheck() {
    try {
      MainAppController.showLoading();
      this.ticketIssue = new CheckIssuePusatResolusi();
      this.ticketIssue = await PusatResolusiV2Controller.checkIssue(
        new CheckTicketPusatResolusiRequest({
          refNo: this.refNo
        })
      );
      const action = this.ticketIssue.action.toUpperCase() || "";
      if (action === "VIEW_DETAIL") {
        this.toDetail(this.ticketIssue.id);
      } else {
        if (!action) {
          this.showPopupReportIssue = true;
        } else {
          this.showPopupInformationIssue = true;
        }
      }
      this.onClickCheckIssueButton();
    } catch (error) {
      if (error?.response?.status === 404) {
        this.showPopupReportIssue = true;
        this.onClickCheckIssueButton();
      } else {
        MainAppController.showErrorMessage(
          parsingErrorResponse(error, "Cek Kendala Gagal!", () => {
            this.onCheck();
            MainAppController.closeErrorMessage();
          })
        );
      }
      this.ticketIssue = new CheckIssuePusatResolusi();
    } finally {
      MainAppController.closeLoading();
    }
  }

  closeModalError() {
    this.isError = false;
    this.errorCause = "";
  }
}
